import { render } from "./EmbeddingBatchModal.vue?vue&type=template&id=1726b4e8&scoped=true"
import script from "./EmbeddingBatchModal.vue?vue&type=script&lang=js"
export * from "./EmbeddingBatchModal.vue?vue&type=script&lang=js"

import "./EmbeddingBatchModal.vue?vue&type=style&index=0&id=1726b4e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1726b4e8"]])

export default __exports__